export { SwapComponentDirective } from './swap-component.directive';
export { BaseDynamicComponent } from './base-dynamic-component';
export { CSSBackdrop } from './css-backdrop';
export { CSSDialogContainer } from './css-dialog-container';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-modal/esm/components/index.js
// module id = 152
// module chunks = 3